module.exports = __webpack_public_path__ + "img/salsa_1974.36530dc8.jpg";